export const LIST = 'LIST';

export default {
    LIST,
};
